import inMainScreen from './inMainScreen';

export default inMainScreen;
